import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "login-right" }
const _hoisted_3 = { class: "login-right-content" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "alert alert-success alert-dismissible custom-alert" }
const _hoisted_7 = { class: "form-floating-custom" }
const _hoisted_8 = { class: "btn-container" }
const _hoisted_9 = {
  key: 0,
  type: "submit",
  class: "btn-login-main"
}
const _hoisted_10 = {
  key: 1,
  class: "btn-login-main",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "login-left" }, [
      _createElementVNode("h1", { class: "main-title" }, [
        _createTextVNode("Welcome back to"),
        _createElementVNode("br"),
        _createTextVNode("Clementine Analytics")
      ]),
      _createElementVNode("p", { class: "main-subtitle" }, "Enter your email to receive a password recovery link")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "login-header-text" }, [
          _createElementVNode("h2", null, "Forgot Password"),
          _createElementVNode("p", null, "We'll help you get back into your account")
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
          class: "w-100"
        }, [
          (_ctx.isSent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createTextVNode(" A recovery email has been sent to ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.email), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-envelope input-icon" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              name: "email",
              id: "forgetEmail",
              placeholder: " ",
              type: "email",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              required: "",
              autocomplete: "email"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "forgetEmail" }, "Email Address", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.isSendEmailLoader)
              ? (_openBlock(), _createElementBlock("button", _hoisted_9, _toDisplayString(_ctx.isSent ? 'Resend Recovery Link' : 'Send Recovery Link'), 1))
              : (_openBlock(), _createElementBlock("button", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("span", {
                    class: "spinner-border spinner-border-sm me-2",
                    role: "status",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createTextVNode(" Sending... ", -1)
                ]))])),
            _createElementVNode("button", {
              class: "btn-back-login",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/login')))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1),
              _createTextVNode("Return to Login ", -1)
            ]))])
          ])
        ], 32)
      ])
    ])
  ]))
}